import useMergedState from "rc-util/es/hooks/useMergedState";
export { useMergedState as useMountMergeState };